import request from "@/utils/request";

// 获取围栏列表
export function getFencePageList(data) {
  return request({
    url: "/open/roads/fence/page",
    method: "post",
    data: data
  });
}

// 获取围栏详情
export function getFenceDetail(fenceId) {
  return request({
    url: "/open/roads/fence/info?fenceId=" + fenceId,
    method: "get"
  });
}



// 获取道路围栏列表
export function getFenceList() {
  return request({
    url: "/open/roads/fence/list",
    method: "get"
  });
}

// 添加道路围栏列表
export function saveRoadsFence(data) {
  return request({
    url: "/open/roads/fence/save",
    method: "post",
    data: data
  });
}

// 修改道路围栏列表
export function updateRoadsFence(data) {
  return request({
    url: "/open/roads/fence/update",
    method: "post",
    data: data
  });
}

// 删除道路围栏列表
export function deleteRoadsFence(data) {
  return request({
    url: "/open/roads/fence/update",
    method: "post",
    data: data
  });
}